import { useTheme } from '@mui/material/styles';
import { yellow, grey, purple } from '@mui/material/colors';


export const SalaryDashboardStyles = () => {
    const theme = useTheme();
    return {
        "& .toggle-acad-level": {
            padding: '10px'
        },
        "& .toggle_button": {
            padding: "14px",
            border: "none",
            textTransform: "uppercase",
            borderRadius: "8px",
            background: theme.palette.purpleCold.dark,
            color: "#fff",
            width: "100%"
        },
        "& .filter_text": {
            padding: "10px",
            textAlign: "center",
            width: "100%",
            fontWeight: "bold",
            margin: "0 auto"
        },
        "& .lollipop_section": {
            marginTop: "12px",
        },
        "& .var-option": {
            background: `${grey[100]}`,
            padding: "4px 17px 12px",
        },
        "& span.filter__counter": {
            float: "right",
            paddingRight: "20px",
            fontSize: "12px",
            fontWeight: "bold",
            paddingTop: "4px",
        },
        "& .MuiSvgIcon-root": {
            margin: "2px 5px 0 5px",
            fontSize: "1.3rem"
        },
        "& .nulls-block": {
            fontSize: "12px",
            padding: "18px",
        },
        "& .nulls-block__districts": {
            paddingLeft: 0,
            margin: "6px 0",
            "& > li": {
                display: "inline-flex",
                alignItems: "center",
                marginRight: "14px",
                width: {
                    xs: "100%",
                    sm: "calc(50% - 16px)",
                    md: "auto"
                }
            },
            "& > li:before": {
                background: `${grey[700]}`,
                borderRadius: "50%",
                content: '""',
                display: "block",
                height: "4px",
                marginRight: "4px",
                width: '4px',
            }
        },
        "& .custom-groups__filter-actions": {
            textAlign: "left",

            "& button": {
                marginLeft: "10px"
            }
        },
        "& .MuiDataGrid-columnHeaderTitleContainer": {
            justifyContent: "center",

            "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold",
            }
        },
        "& .salary-table": {
            "&__title": {
                margin: "20px auto 0",
                fontWeight: "bold",
                textAlign: "center",
            },
            "&__notes": {
              "& span":{
                  background: `${purple[50]}`,
                  display: "inline-block",
                  marginRight: "6px",
                  height: "20px",
                  width: "20px"
              }
            }
        },
        "& .step-cell": {
            background: `${yellow[100]}`,
        },
        "& .salary-column": {
            display: "flex !important",
            justifyContent: "space-around !important",

            "&.ba-column": {
              borderRight: `1px dotted ${grey[400]}`
            },

            "&.calculated_index": {
                background: `${purple[50]}`,
            },
            "& .salary-value": {
                fontWeight: "bold",
            }
        },
        "& .editors-notes": {
            ".label": {
                fontWeight: "bold"
            },
            "ul": {
                marginTop: 0,
            }
        }
    }
}

export const nullsBlockAccordion = {
    background: `${grey[100]}`,
}